import { render } from "./BuddhaAI.vue?vue&type=template&id=6df64874&scoped=true"
import script from "./BuddhaAI.vue?vue&type=script&lang=js"
export * from "./BuddhaAI.vue?vue&type=script&lang=js"

import "./BuddhaAI.vue?vue&type=style&index=0&id=6df64874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df64874"]])

export default __exports__